import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "../Reveal";
import { STATS } from "../../lib/site";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-20%" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const duration = 1600;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="tabular-nums">
      {display}
      {suffix}
    </span>
  );
};

export const Innovation = () => {
  return (
    <section data-testid="innovation-section" className="relative bg-ink py-24 md:py-32 lg:py-40">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-end mb-20">
          <Reveal className="lg:col-span-7">
            <p className="overline mb-5">Innovation · nTHERM</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-textmain leading-[0.95]">
              The materials-science<br />edge
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="text-textmuted text-base md:text-lg leading-relaxed">
              Our proprietary <span className="text-textmain font-medium">nTHERM</span> composite
              redefines the performance envelope — dramatically lighter, tougher, and more
              thermally resilient than legacy materials. It is the invisible advantage
              inside every Ascendance product.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {STATS.map((stat, i) => (
            <Reveal key={stat.label} delay={i * 0.08}>
              <div
                data-testid={`stat-${i}`}
                className="group border-r border-b border-white/10 p-8 md:p-10 h-full hover:bg-panel transition-colors duration-500"
              >
                <div className="font-heading text-5xl md:text-6xl font-bold text-steel mb-4 group-hover:scale-105 origin-left transition-transform duration-500">
                  <Counter value={stat.value} suffix={stat.suffix} />
                </div>
                <h3 className="font-heading text-lg font-semibold uppercase tracking-wide text-textmain mb-1">
                  {stat.label}
                </h3>
                <p className="text-sm text-textmuted">{stat.sub}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
